import { AxiosError } from 'axios';

export function getBackendErrorDetail(error: AxiosError) {
  if (typeof error.response?.data === 'string') {
    return error.response.data;
  } else if (error.response?.data.length > 0) {
    return error.response?.data[0];
  } else if (typeof error.response?.data === 'object') {
    return error.response.data.detail;
  } else {
    throw new Error('Could not parse Axios error details.');
  }
}
